<div class="legal-page">
  <header class="legal-header">
    <span class="legal-header__brand">CapX</span>
    <a [routerLink]="['/auth/register']" class="legal-header__back"
      ><app-icon name="chevron-left" [size]="16" /> Back to registration</a
    >
  </header>

  <div class="legal-content">
    <h1 class="legal-content__title">Terms &amp; Conditions</h1>

    @if (isLoading()) {
      <div class="legal-content__loading" aria-live="polite" aria-busy="true">
        <mat-spinner diameter="32" />
        <span class="legal-content__loading-text">Loading…</span>
      </div>
    } @else if (hasError()) {
      <div class="legal-content__error" role="alert">
        <p>Couldn't load the Terms &amp; Conditions.</p>
        <button mat-stroked-button type="button" (click)="reload()">Try again</button>
      </div>
    } @else if (content()) {
      <div class="legal-content__body" [innerHTML]="content() | markdown"></div>
    }
  </div>
</div>
